import styled from 'styled-components'

const AuthBackground = styled.div`
  background-size: cover;
  height: 100vh;
  position: relative;
  overflow: auto;
`

export default AuthBackground



// WEBPACK FOOTER //
// ./src/components/auth/AuthBackground.js